module.exports = __webpack_public_path__ + "img/RefinanceYourMortgage.9128a69a.jpeg";